import * as React from "react";

import "./analytics-overview.scss";
import { InformationBadge } from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faMobileScreen, faQrcode, faSquareEnvelope } from "@fortawesome/free-solid-svg-icons";

const QR_ANALYTIC = 'qr'
const FORM_ANALYTIC = 'formSubmission'
const INFORMED_DELIVERY_ANALYTIC = 'informedDelivery'
const PHYSICAL_IMPRESSIONS_TOOLTIP = "House Views and Attention Time estimates are based on average engagement behavior tracked by JICMAIL and USPS studies.";
const HOUSEHOLD_VIEWS_TOOLTIP = <>
    <div className="tip">Household view estimates are based on average engagement behavior tracked by JICMAIL and USPS studies. Most mail is seen more than once, often by multiple people in the home.</div>
    <div className="subtext">SOURCES:</div>
    <div className="subtext">1. JICMAIL UK Data 2023 – validated by USPS Mail Moments trends</div>
    <div className="subtext">2. JICMAIL Insights (https://www.jicmail.org.uk/)</div>
    <div className="subtext">3. Reinforced by USPS Mail Moments studies, which show 88–90% of mail is reviewed and shared in the household</div>
</>
const VIEW_TIME_TOOLTIP = <>
    <div className="tip">This estimate reflects how much total attention your campaign likely received based on average U.S. household mail interaction time.</div>
    <div className="subtext">Source: JICMAIL Attention Study, 2023 (https://resimpli.com/blog/direct-mail-statistics/)</div>
</>;
const EMAILS_SENT_TOOLTIP = "Based on USPS national averages";
const EMAILS_OPENED_TOOLTIP = "Based on USPS national averages";

export const AnalyticsOverview = ({leadInteractions, orderCounts}) => {
    return (
        <div className="analytics-overview-yeet1">
            <AnalyticsPhysicalImpressions {...{leadInteractions, orderCounts}} />
            <AnalyticsDigitalEngagement {...{leadInteractions, orderCounts}} />
        </div>
    )

}

const AnalyticsPhysicalImpressions = ({leadInteractions, orderCounts}) => {
    const quantity = orderCounts?.totalQuantity;
    const qrCount = orderCounts?.hasTracking;
    return (
        <div className="card">
            <div className="title">
                <div className="title-text">
                    Physical Impressions
                </div>
                {InformationBadge({
                    height: 10,
                    getTooltip: () => PHYSICAL_IMPRESSIONS_TOOLTIP,
                    xdQaName: "Contact Xpressdocs",
                })}
            </div>
            <div className="content">
                <div className="mailers">
                    <div className="count">
                        {formatCount(quantity)}
                    </div>
                    <div className="description">
                        MAILERS SENT
                    </div>
                </div>
                <div className="card">
                    <div className="title">
                        <div className="icon">
                            <FontAwesomeIcon className={"icon"} icon={faEye}/>
                        </div>
                        <div className="title-text">
                            Engagement Data
                        </div>
                    </div>
                    <div className="content">
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                    {formatCount(quantity * 2.5)}
                                </div>
                            </div>
                            <div className="description">
                                Household views
                                {InformationBadge({
                                    height: 10,
                                    getTooltip: () => HOUSEHOLD_VIEWS_TOOLTIP,
                                    xdQaName: "Contact Xpressdocs",
                                })}
                            </div>
                        </div>
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                    {formatCount(quantity * 108 / 60 / 60)}
                                </div>
                                <div className="count-subtext">
                                    Hours
                                </div>
                            </div>
                            <div className="description">
                                View Time
                                {InformationBadge({
                                    height: 10,
                                    getTooltip: () => VIEW_TIME_TOOLTIP,
                                    xdQaName: "Contact Xpressdocs",
                                })}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="title">
                        <div className="icon">
                            <FontAwesomeIcon className={"icon"} icon={faQrcode}/>
                        </div>
                        <div className="title-text">
                            QR Scans
                        </div>
                    </div>
                    <div className="content">
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                    {formatCount(qrCount)}
                                </div>
                            </div>
                            <div className="description">
                                Mailers with QR
                            </div>
                        </div>
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                    {analyticSum(analyticCount(leadInteractions, QR_ANALYTIC), 0)}
                                </div>
                            </div>
                            <div className="description">
                                QR Scans
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const AnalyticsDigitalEngagement = ({leadInteractions, orderCounts}) => {
    const informedDeliveryCount = orderCounts?.hasInformedDelivery;
    return (
        <div className="card">
            <div className="title">
                <div className="title-text">
                    Digital Engagement
                </div>
            </div>
            <div className="content digital">
                <div className="card">
                    <div className="title">
                        <div className="icon">
                            <FontAwesomeIcon className={"icon"} icon={faMobileScreen}/>
                        </div>
                        <div className="title-text">
                            Virtual Interactions
                        </div>
                    </div>
                    <div className="content">
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                {analyticSum(analyticCount(leadInteractions, FORM_ANALYTIC), 0)}
                                </div>
                            </div>
                            <div className="description">
                                Form Fills
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card">
                    <div className="title">
                        <div className="image">
                            <img src={require("./uspslogo.png")} alt="USPS"/>
                        </div>
                        <div className="title-text">
                            Informed Delivery by USPS<sup>®</sup>
                        </div>
                    </div>
                    <div className="content">
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                    {formatCount(informedDeliveryCount)}
                                </div>
                            </div>
                            <div className="description">
                                Mailers with ID
                            </div>
                        </div>
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                    {formatCount(informedDeliveryCount * 0.347)}
                                </div>
                            </div>
                            <div className="description">
                                Emails Sent
                                {InformationBadge({
                                    height: 10,
                                    getTooltip: () => EMAILS_SENT_TOOLTIP,
                                    xdQaName: "Contact Xpressdocs",
                                    direction: "south-west"
                                })}
                            </div>
                        </div>
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                    {formatCount(informedDeliveryCount * 0.347 * 0.586)}
                                </div>
                            </div>
                            <div className="description">
                                Emails Opened
                                {InformationBadge({
                                    height: 10,
                                    getTooltip: () => EMAILS_OPENED_TOOLTIP,
                                    xdQaName: "Contact Xpressdocs",
                                    direction: "south-west"
                                })}
                            </div>
                        </div>
                        <div className="sub-content">
                            <div className="count">
                                <div className="count-text">
                                    {analyticSum(analyticCount(leadInteractions, INFORMED_DELIVERY_ANALYTIC), 0)}
                                </div>
                            </div>
                            <div className="description">
                                Clicks
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const analyticCount = (leadInteractions, key) => {
    const counted = leadInteractions.reduce((accumulator, object) => {
        const values = object[key]

        if(values) {
            Array.isArray(values)
            ?   values.forEach(value => {
                    accumulator[value] = (accumulator[value] || 0) + 1
                })
            :   accumulator[values] = (accumulator[values] || 0) + 1
        }
        return accumulator
    }, {})

    const countedArray = Object.entries(counted).map(([value, count]) => {
        return { [key]: value, count: count }
    })

    countedArray.sort((a, b) => b.count - a.count)

    return countedArray
}

export const analyticSum = (countedArray, displayMax = 3) => {
    let sum = 0
    const limit = !displayMax ? countedArray.length : countedArray.length < displayMax ? countedArray.length : displayMax
    for(let i = 0; i < limit; i++) {
        sum += countedArray[i].count
    }
    return sum
}

const formatCount = (count: number): string => {
    if (!count) {
        return '0';
    }
    const format = (value: number, suffix: string) => {
        let str = (Math.round(value * 100) / 100).toString();
        if (value >= 100) {
            str = Math.round(value).toString();
        } else if (value >= 10) {
            str = (Math.round(value * 10) / 10).toString();
        } else {
            str = (Math.round(value * 100) / 100).toString();
        }
        str = str.replace(/\.?0+$/, '');
        return str + suffix;
    };

    if (count >= 1_000_000_000) {
        return format(count / 1_000_000_000, 'B');
    } else if (count >= 1_000_000) {
        return format(count / 1_000_000, 'M');
    } else if (count >= 1_000) {
        return format(count / 1_000, 'k');
    } else {
        return (Math.round(count * 100) / 100).toString().replace(/\.?0+$/, '');
    }
};